<template>
  <w-sliding-popup ref="connectionSettingPopup" title="접속 설정" width="400px" @close="onClosePopup">
    <div slot="content">
      <el-form ref="form" :model="formData" :rules="formRules" label-position="top">
        <el-row>
          <el-form-item label="IP 주소" prop="ipaddress">
            <el-input v-model="formData.ipaddress"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="포트" prop="snmpPort">
            <el-input v-model="formData.snmpPort"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="Community" prop="snmpCommunityRead">
            <el-input type="password" v-model.number="formData.snmpCommunityRead"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="SNMP 버전" prop="snmpVersion">
            <el-select v-model="formData.snmpVersion" style="width:100%">
              <el-option v-for="item in snmpVersionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid" />
            </el-select>
          </el-form-item>
        </el-row>
        <div v-if="formData.snmpVersion === 'V3'">
          <el-row>
            <el-form-item label="User Name" prop="snmpV3Username">
              <el-input v-model="formData.snmpV3Username"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="Context" prop="snmpV3ContextId">
              <el-input v-model="formData.snmpV3ContextId"></el-input>
            </el-form-item>
          </el-row>
          <el-row style="display:flex">
            <el-form-item label="Auth" prop="snmpV3AuthProtocol">
              <el-select v-model="formData.snmpV3AuthProtocol" class="mr-r4" style="width:100px">
                <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid" />
              </el-select>
            </el-form-item>
            <el-form-item label="비밀번호" prop="snmpV3AuthPassword" style="width:100%">
              <el-input type="password" v-model="formData.snmpV3AuthPassword" :disabled="formData.snmpV3AuthProtocol === 'NONE'"></el-input>
            </el-form-item>
          </el-row>
          <el-row style="display:flex">
            <el-form-item label="Privacy" prop="snmpV3PrivProtocol">
              <el-select v-model="formData.snmpV3PrivProtocol" class="mr-r4" style="width:100px">
                <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid" />
              </el-select>
            </el-form-item>
            <el-form-item label="비밀번호" prop="snmpV3PrivPassword" style="width:100%">
              <el-input type="password" v-model="formData.snmpV3PrivPassword" :disabled="formData.snmpV3PrivProtocol === 'NONE'"></el-input>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEqual, isNil, cloneDeep } from 'lodash';
import { validateIpv4 } from '@/utils/string';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';

export default {
  name: 'WConnectionSettingPopup',
  props: {
    ipaddress: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedRows: [],
      formData: {
        ipaddress: null,
        snmpPort: null,
        snmpCommunityRead: null,
        snmpVersion: 'V1/V2',
        snmpV3AuthProtocol: 'NONE',
        snmpV3PrivProtocol: 'NONE',
      },
      formRules: {
        ipaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validateIpaddress,
        },
        snmpPort: {
          required: true,
          trigger: 'blur',
          message: '필수 정보입니다',
        },
        snmpCommunityRead: {
          required: true,
          trigger: 'blur',
          message: '필수 정보입니다',
        },
        snmpVersion: {
          required: true,
          trigger: 'change',
          message: '필수 정보입니다',
        },
        snmpV3Username: {
          required: true,
          trigger: 'blur',
          message: '필수 정보입니다',
        },
        snmpV3AuthProtocol: {
          required: true,
          trigger: 'change',
          message: '필수 정보입니다',
        },
        snmpV3PrivProtocol: {
          required: true,
          trigger: 'change',
          message: '필수 정보입니다',
        },
        snmpV3AuthPassword: {
          required: false,
          trigger: 'blur',
          message: '필수 정보입니다',
        },
        snmpV3PrivPassword: {
          required: false,
          trigger: 'blur',
          message: '필수 정보입니다',
        },
      },
      snmpVersionList: [],
      snmpAuthList: [],
      snmpPrivList: [],
    };
  },
  watch: {
    'formData.snmpVersion': {
      handler(to) {
        if (to === 'V3') {
          this.formRules.snmpCommunityRead.required = false;
        } else {
          this.formRules.snmpCommunityRead.required = true;
        }
        if (!isNil(this.$refs.form)) {
          this.$refs.form.clearValidate('snmpCommunityRead');
        }
      },
    },
    'formData.snmpV3AuthProtocol': {
      handler(to) {
        if (to === 'NONE') {
          this.formRules.snmpV3AuthPassword.required = false;
        } else {
          this.formRules.snmpV3AuthPassword.required = true;
        }
        if (!isNil(this.$refs.form)) {
          this.$refs.form.clearValidate('snmpV3AuthPassword');
        }
      },
    },
    'formData.snmpV3PrivProtocol': {
      handler(to) {
        if (to === 'NONE') {
          this.formRules.snmpV3PrivPassword.required = false;
        } else {
          this.formRules.snmpV3PrivPassword.required = true;
        }
        if (!isNil(this.$refs.form)) {
          this.$refs.form.clearValidate('snmpV3PrivPassword');
        }
      },
    },
  },
  mounted() {
    this.loadSnmpInfo();
  },
  methods: {
    loadSnmpInfo() {
      BasicinfoSubAPI.getList('SNMPVER').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data.filter((item) => !isEqual(item.basicinfoSubid, 'NONE'));
          this.snmpVersionList = cloneDeep(resultData);
        }
      });
      BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data;
          this.snmpAuthList = cloneDeep(resultData);
        }
      });
      BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data;
          this.snmpPrivList = cloneDeep(resultData);
        }
      });
    },
    open() {
      this.formData.ipaddress = this.ipaddress;
      this.$refs.connectionSettingPopup.visible = true;
    },
    onClosePopup() {
      this.$emit('set-ipaddress', cloneDeep(this.formData.ipaddress));
      this.$refs.connectionSettingPopup.visible = false;
      this.tableData = [];
    },
    setFormData(objInfo) {
      Object.assign(this.formData, objInfo);
    },
    validateIpaddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다'));
      } else if (!validateIpv4(value)) {
        callback(new Error('IP를 확인해주세요'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/MibBrowser/popup/ConnectionSettingPopup.vue